import { Navigate, Route, Routes } from 'react-router-dom'
import Layout from '../UI/Layout/Layout'
import { Level } from '../../types/Auth'
import Settings from './Settings/Settings'
import Customer from './Customer/Customer'
import Project from './Project/Project'
import SurveyContext from './Survey/SurveyContext'
import NAW from './NAW/NAW'
import Controlling from './Controlling/Controlling'

const Admin = () => {
  return (
    <Layout authLevelRequired={[Level.ADMIN]} noFooter>
      <Routes>
        {/* default routes */}
        <Route path={'customer/*'} element={<Customer />} />
        <Route path={'project/*'} element={<Project />} />
        <Route path={'survey/*'} element={<SurveyContext />} />
        <Route path={'settings'} element={<Settings />} />

        {/* naw-configurator routes */}
        <Route path={'naw/*'} element={<NAW />} />

        {/* controlling */}
        <Route path={'controlling/*'} element={<Controlling />} />

        {/* fallback route */}
        <Route path={'*'} element={<Navigate replace to="/admin/customer" />} />
      </Routes>
    </Layout>
  )
}

export default Admin
